import * as React from "react"
import { observer } from "mobx-react-lite"
import { JalaLoading } from "../jala-loading/jala-loading"
import { View, Modal, IModalProps } from "native-base"
import { useIsFocused } from "@react-navigation/native"

export interface ModalJalaLoadingProps extends IModalProps {
  //
}

/**
 * Describe your component here
 */
export const ModalJalaLoading = observer(function ModalJalaLoading(props: ModalJalaLoadingProps) {
  const isFocused = useIsFocused()

  return isFocused && <Modal {...props}>
    <View
      width="72px" height="72px"
      alignItems="center"
      justifyContent="center"
      rounded="48px"
      backgroundColor="rgba(255, 255, 255, 0.75)"
    >
      <JalaLoading />
    </View>
  </Modal>
})
